const MessageTypes = {
	NOTIFICATION: 1,
	MAIL: 2
};

export default MessageTypes;